// NOTE: this will support the tailwind font boldnesses/ italics of:
// normal, semibold, bold, normal italic, italic bold
// ADD MORE WEIGHTS AS NEEDED
export const getFontWeightsString = (font: string) => {
  return `${font}:ital,wght@0,400;0,600;0,700;1,400;1,700`;
};

export const createGoogleFontsCDNLink = (...fonts: string[]) => {
  const url = new URL('https://fonts.googleapis.com/css2');

  const uniqueFonts = new Set(fonts);

  uniqueFonts.forEach((font) => {
    url.searchParams.append('family', getFontWeightsString(font));
  });

  url.searchParams.set('display', 'swap');
  const href = url.toString();

  return href;
};
